export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Nursing Instructor Atlas after purchasing?',
    a: ['You receive instant digital access to the materials after your payment is successfully completed.'],
  },
  {
    q: 'What format is it in?',
    a: [
      'All materials are delivered as PDF files. You can print them as handouts or show them on a tablet, screen or projector in your classroom, skills lab, simulation room or clinical unit.',
    ],
  },
  {
    q: 'Who is it for?',
    a: [
      'It is designed for nursing instructors, clinical faculty, nurse educators, skills-lab and simulation coordinators, clinical preceptors and nursing assistant, LPN/LVN and RN program instructors. Adjust the content to your students, your level and your own curriculum.',
    ],
  },
  {
    q: 'What levels does it cover?',
    a: [
      'From beginner to advanced. Training pages include Easy, Standard and Advanced variants, so you can match each session to your students.',
    ],
  },
  {
    q: 'Does it work for nursing assistant, LPN and RN programs?',
    a: [
      'Yes. The material covers nursing fundamentals, health assessment, nursing procedures, pharmacology and dosage calculation, medical-surgical and emergency care, and clinical teaching methods, so it works for nursing schools, nursing assistant and LPN/LVN programs, RN programs and continuing-education workshops alike.',
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'Yes. The six volumes contain 300 visual training pages (50 per volume). Each page includes an illustration or labeled diagram, a step-by-step breakdown when it applies, a ❌ common mistake vs. ✅ correct technique comparison, a teaching cue, a drill and a quick check. The five bonuses add practical teaching tools.',
    ],
  },
  {
    q: 'Does it include ready-to-teach lessons?',
    a: [
      'Yes. The system is built around a simple method — OPEN → CHOOSE → SHOW → TEACH — with lesson plans, demonstration guides, simulation scenarios, drills and quick checks you can use right away.',
    ],
  },
  {
    q: 'What topics does it cover?',
    a: [
      'Nursing fundamentals, patient care and essential clinical skills; human anatomy, health assessment and clinical examination; nursing procedures, clinical interventions and patient safety; nursing pharmacology, medication administration and dosage calculations; medical-surgical nursing, emergency care and clinical decision-making; and nursing instruction, clinical simulation and competency assessments.',
    ],
  },
  {
    q: 'Does it replace accredited nursing education or clinical guidelines?',
    a: [
      'No. This is educational teaching-support material for instructors. It does not replace an accredited nursing curriculum, licensure requirements, current clinical guidelines, local regulations or qualified clinical supervision. Always follow your institution’s policies and protocols, especially for medication administration, invasive procedures and emergency care.',
      'Results depend on each instructor, student and training context, so no specific results are guaranteed.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. The complete package includes all six visual nursing education and clinical training volumes.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. The five listed bonuses are included with the complete package at no additional cost under this offer.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. This is a digital educational resource package containing PDF materials. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. The materials are written in English for an international audience and use generic medication names.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['The materials are provided as PDFs, not editable source files.'],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. The listed package is offered as a one-time payment, with no subscription.'],
  },
]
